import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { UrlNames } from 'src/app/enumerates/url-name';
import { NavigationState } from 'src/app/models/navigation/navigation-state';
import { navigate } from 'src/app/reducers/navigation/navigation.actions';
import { PermissionService } from 'src/app/services/user/permission.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
    activeTab = 0;
    currentUrl: string;
    display = {
        schedule: false,
        workout: false,
        chat: false
    };

    constructor(private readonly router: Router, private readonly store: Store<{ navigation: NavigationState }>, private permissionService: PermissionService) {
        this.currentUrl = '';
    }

    ngOnInit(): void {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.router.events.subscribe((event: any) => {
            this.currentUrl = event.url;
            if (this.currentUrl === `/${UrlNames.schedule}`) {
                this.activeTab = 0;
            } else if (this.currentUrl === `/${UrlNames.workout}`) {
                this.activeTab = 1;
            } else if (this.currentUrl === `/${UrlNames.chat}`) {
                this.activeTab = 2;
            }
        });
        this.display = {
            schedule: this.permissionService.isActiveSubsectionFitness(),
            workout: this.permissionService.canAssignWorkoutsPermission(),
            chat: false // this.permissionService.hasStaffChatActive()  TODO: uncomment for feature of chat
        };
    }

    goTo(event: any): void {
        if (this.activeTab !== event.index) {
            this.activeTab = event.index;
            if (this.activeTab === 0) { // TODO: ¿Sustituimos esto valores por enum?
                this.store.dispatch(navigate({ url: '/schedule' }));
            } else if (this.activeTab === 1) {
                this.store.dispatch(navigate({ url: '/workout' }));
            } else if (this.activeTab === 2) {
                this.store.dispatch(navigate({ url: '/chat' }));
            }
        }
    }
}
